import type { ComponentProps } from 'react'
import React, { memo } from 'react'
import type { Icon108, Icon18, Icon32, Icon36 } from 'kidsout:icons'

import { useAppDispatch } from '@app/utils/redux'

import { getIconContext } from '@app/store/actions/contexts/IconContext'

import { SVG } from '@app/components/SVG/SVG'

import classes from './Icon.module.scss'

export type IconProps = (
  | {
      size?: '18'
      icon: Icon18
    }
  | {
      size: '32'
      icon: Icon32
    }
  | {
      size: '36'
      icon: Icon36
    }
  | {
      size: '108'
      icon: Icon108
    }
) &
  ComponentProps<'span'> & {
    /** Accessible name for the icon (see SVG's `alt`): non-empty → role="img"; "" → decorative. */
    alt?: string
  }

export const Icon = memo<IconProps>(function Icon({ icon, size = '18', className, ...props }) {
  const dispatch = useAppDispatch()
  const { useIcon } = dispatch(getIconContext())
  const data = useIcon(size, icon)
  if (!data) return null
  return <SVG {...props} className={className} content={data} label={icon} />
})

export const InlineIcon = memo<IconProps>(function Icon({ icon, size = '18', className, ...props }) {
  const dispatch = useAppDispatch()
  const { useIcon } = dispatch(getIconContext())
  const data = useIcon(size, icon)
  if (!data) return null
  return <SVG {...props} className={cn(classes.inline_icon, classes[`inline_icon_size_${size}`], className)} content={data} label={icon} />
})
